module.exports = __webpack_public_path__ + "img/template3-old.ca58ea11.png";